var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Services',"subtitle":`${_vm.data[_vm.service]?.service_type_name}`}}),(!_vm.loading)?_c('div',[_c(`${_vm.service}-form`,{tag:"component",attrs:{"service-type":_vm.data[_vm.service],"service-type-id":_vm.serviceTypeId,"action":"edit"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }